import { act, useState } from "react";

import { Grid, Typography, Box, Button, Stack } from "@mui/material";
import { CartCard, CartArrow } from "components/unitComponent";
import { SvgIconStyle } from "components";
import Slider from "react-slick";

import CartIcon from "assets/icons/cart.svg";
import CancelIcon from "assets/icons/cancel.svg";

export default function CartSlider({ language,cart, t, total, onDeleteAll, onDelete }) {
	const [active, setActive] = useState(false);

	const itemSliderSetting = {
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 3,
		nextArrow: <CartArrow />,
		prevArrow: <CartArrow prev />,
	};

	return (
		<Box
			sx={{
				position: "relative",
				zIndex: 10,
				height: active ? 204 : 124,
				pr: "38px",
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-end",
			}}
		>
			{/* 장바구니 슬라이더 */}
			<Box
				sx={{
					position: "absolute",
					right: active ? 38 : "100vw",
					bgcolor: "grey.600",
					width: "calc(100% - 38px)",
					height: "100%",
					p: 2,
					pr: 16,
					borderRadius: "0 100px 100px 0",
					boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.20)",
					transitionDuration: "0.8s",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				{cart.length > 0 ? (
					<Box
						sx={{
							width: "100%",
							height: "100%",
							overflowX: "scroll",
							overflowY: "hidden",
						}}
					>
						<Box
							sx={{
								width: "max-content",
								display: "flex",
								gap: 1.5,
							}}
						>
							{cart.map((item, i) => (
								<CartCard
								language={language}
									index={i}
									key={i}
									item={item}
									onClick={() => onDelete(item)}
									t={t}
								/>
							))}
						</Box>
					</Box>
				) : (
					<Typography variant="h4" color="grey.200">
						{t("empty")}
					</Typography>
				)}
			</Box>
			{/* 버튼 */}
			<Button
				aria-label={t("cart")}
				aria-expanded={active}
				variant="contained"
				className={cart.length > 0 ? "active" : ""}
				sx={{
					position: "relative",
					width: 92,
					height: 92,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					borderRadius: 100,
					mr: 2,
					bgcolor: "black !important",
					boxShadow: " 0px 0px 10px 0px rgba(0, 0, 0, 0.20) !important",
					transitionDuration: "0.5s",
					"&.active": { bgcolor: "#FF006E !important" },
				}}
				onClick={() => {
					setActive(!active);
				}}
			>
				{cart.length > 0 ? (
					<Box
						sx={{
							position: "absolute",
							top: -4,
							right: -1,
							color: "black",
							border: "1px solid #ff006e",
							bgcolor: "white",
							borderRadius: "100px",
							width: 32,
							height: 32,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<Typography variant="h4">{cart.reduce(
												(acc, item) => acc + item.buyCount,
												0
										  )}</Typography>
					</Box>
				) : (
					""
				)}
				<SvgIconStyle
					src={active ? CancelIcon : CartIcon}
					color={"white"}
					size={48}
				/>
			</Button>
		</Box>
	);
}
